import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PhproductformFilterCriteria from './PhproductformFilterCriteria'
import PhproductformList from './PhproductformList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PhproductformAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPhproductformDashboardPhproductformList } from '../../store/slice/PharmaSlice';

export default function PhproductformListView({setShowEdit,setPhproductformId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.phproductformDashboard);   

    const [filteredPhproductformList, setFilteredPhproductformList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { phproductformDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (phproductformDashboard.phproductformList.length>-1){
        setFilteredPhproductformList(phproductformDashboard.phproductformList);
        transformToCardFormat(phproductformDashboard.phproductformList, setCardList);
      }
    },[phproductformDashboard.phproductformList])

    useEffect(()=>{
          transformToCardFormat(filteredPhproductformList, setCardList);
      },[filteredPhproductformList])

    useEffect(()=>{
        if (filterCriteria.businessid==='' && filterCriteria.title==='' ){
            setFilteredPhproductformList(phproductformDashboard.phproductformList);
            transformToCardFormat(phproductformDashboard.phproductformList, setCardList);

        } else {
            setFilteredPhproductformList(
                phproductformDashboard.phproductformList
                    
                
            )
            

            //transformToCardFormat(phproductformDashboard.filteredPhproductformList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PhproductformList
                    setShowEdit={setShowEdit}
                    setPhproductformId = {setPhproductformId}
                    tableList={filteredPhproductformList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}